export const STATUSES = Object.freeze({
  IDLE: 'idle',
  SUCCESS: 'success',
  ERROR: 'error',
  LOADING: 'loading',
  LOGGED_IN: 'loggedIn',
  LOGGED_OUT: 'loggedOut',
  POST_CREATED: 'New Post Created',
  POST_DELETED: 'Post Deleted',
  POST_EDITED: 'Post Edited',
  COMMENT_CREATED: 'Added New Comment',
  COMMENT_DELETED: 'Comment Deleted',
  COMMENT_EDITED: 'Comment Edited',
  IS_FOLLOWING: 'Is Following',
  IS_UNFOLLOWING: 'Is Unfollowing',
  SUCCESS_LIKE: 'success_like',
  SUCCESS_UNLIKE: 'success_unlike',
  SUCCESS_BOOKMARK: 'success_bookmark',
  SUCCESS_UNBOOKMARK: 'success_unbookmark',
  POST_LIKED: 'Post Liked',
  POST_UNLIKED: 'Post Unliked',
  POST_BOOKMARKED: 'Post Bookmarked',
  POST_UNBOOKMARKED: 'Removed from Bookmarks',
});
